import { useProfessionalLayoutData } from './use-professional-layout-data';

/**
 * The shared overview payload (identity, summary, featured work, "Talk to us"
 * imagery) the persistent professional layout loads once per professional —
 * the revamped tabs read it from here instead of refetching it per tab
 * switch. Only available while the revamp is active, which is the only time
 * the revamped sections render; throws otherwise so a misplaced usage fails
 * loudly rather than rendering empty.
 */
export const useProfessionalOverviewShared = () => {
    const layoutData = useProfessionalLayoutData();
    const shared = layoutData?.overviewShared;
    if (!shared) {
        throw new Error(
            'useProfessionalOverviewShared requires the professional layout with the details revamp active',
        );
    }
    return shared;
};
